<template>
  <div>
    <div class="form-container ou-donation-form teach-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Registration Options">
            <div>
              <div class="row">
                <div v-for="[amount, description] of amounts" :key="amount" class="amount-row">
                  <input
                    :id="`amount${amount}`"
                    type="radio"
                    class="amount"
                    @click="(selectedAmount = amount)"
                    :checked="(selectedAmount == amount)"
                  />
                  <FormLabel class="label__amount" :for="`amount${amount}`">
                    <div class="label__wrapper" v-html="description"></div>
                  </FormLabel>
                </div>
              </div>
            </div>
            <p class="note">*Price does not include airfare, all participants are responsible for their own travel.</p>
            <ErrorLabel field="amount" />
          </FormSection>
          <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addSplit/>
            </div>
          </FormSection>
          <FormSection title="Your Contact Information">
            <FormRow inline>
              <FormCol :simpleTitle="true" field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://teachcoalition.org/privacy-policy/"/>
                  </FormRow>               
            <div v-if="form.amount && Number(form.amount) && Number(form.amount) === 2000">
              <FormRow>
                <FormLabel class="control-label"> Spouse's Name </FormLabel>
              </FormRow>
              <FormRow >
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.coupleName"
                />
              </FormRow>
            </div>
            <FormRow inline>
              <FormCol field="custom.schoolName" width="half" :showLabel="false">
                <FormLabel class="control-label"> School Affiliation: </FormLabel>
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.schoolName"
                />
              </FormCol>
            </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Total">
            <FormRow>
              <MoneyFormat
                :value="form.amount ? Number(form.amount) : 0"
                :currencyCode="form.currency"
                class="amount-box"
                style="width: 120px;margin-left: 10px;"
              />
            </FormRow>
          </FormSection>
          <FormSection title="Credit Card" last>
            <div class="payment-info">
              <FormRow inline>
                <FormCol
                  class="doublepay"
                  field="card"
                  :showLabel="false"
                  check_text=""
                />
              </FormRow>
            </div>
          </FormSection>
          <!-- <PaymentButton showAmount btnText="Submit" class="teachpay" /> -->
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";

export default defineComponent({  setup(props) {
    const { setValue, form, settings, getValue } = usePaymentForm();
    const selectedAmount = ref();

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        setValue("amount", "" + selectedAmount);
      }
    });

    const amounts = computed(() => {
      const amounts = settings!.amounts! as
        | [number, string][]
        | [Partial<{ [key in Currency]: number }>, string][];

      if (typeof amounts[0][0] == "number") return amounts;

      return (amounts as [
        Partial<{ [key in Currency]: number }>,
        string
        //@ts-ignore
      ][]).map(([amounts, label]) => [amounts[form.value.currency!], label]);
    });

    return {
      form,
      amounts,
      selectedAmount,
      setValue,
      getValue,
    };
  },
});
</script>

<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}

.card-img {
  display: flex;
  img {
    height: 23px;
  }
}

.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}

.donate-intro {
  font-size: 18px;
  line-height: 26px;
  color: #00346b;
  p {
    margin-bottom: 10px;
  }
  a {
    color: #00346b;
    font-weight: 600;
  }
}

.form-container.ou-donation-form.teach-donation-form {
  max-width: 770px;
  box-shadow: none;
  padding: 10px 30px 62px;
  @media only screen and (min-width: 720px) {
    padding: 0px 50px 0px;
    margin: 0px auto;
  }
}

.teach-donation-form ::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  label {
    border: 1px solid #230b01;
    color: white;
    font-size: 15px;
    background: #230b01;
    &:hover {
      // background: #f7f7f7;
    }
  }
  input[type="radio"]:checked + label {
    background: #be9e5f;
  }
  input[type="radio"]:checked + label .label-amount {
    background: #be9e5f;
    border-color: #be9e5f;
  }
  .label-description {
    font-size: 16px;
  }
  .label-amount {
    background: #be9e5f;
    color: white;
  }
  .radio-part {
    min-width: 23%;
    max-width: 23%;
  }
}

.teach-donation-form
  .frequency
  ::v-deep
  .styled-radio-container--ou-donation.styled-radio-container {
  .radio-part {
    min-width: 33%;
    max-width: 33%;
  }
}

.amount-row {
  margin-bottom: 15px;
}

.label__wrapper, .label__amount {
  display: inline !important;
}

.payment {
  margin: 20px auto 20px;
  ::v-deep .ou-donation-btn {
    width: 300px;
    max-width: 100%;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
  }
}

.note {
  font-style: italic;
  line-height: 1.4;
  font-weight: 500;
  font-size: 14px;

  a {
    text-decoration: none;
  }
}

.doublepay {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
